
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  methods: {
    openForm: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: this.values.form_type,
          hideTabs: true,
          miniReachGoal: this.values.reach_goal,
          fullReachGoal: this.values.reach_goal,
        }
      })
    },
  }
});
